<template>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center mb-3">
                <ul class="nav nav-tabs flex-grow-1" v-if="tabs.length > 1 && !templatesOnly">
                    <li class="nav-item" v-for="tab in tabs" :key="tab.key">
                        <a
                            class="nav-link"
                            :class="{ active: !filter.text && currentTab === tab.key }"
                            href="#"
                            @click.prevent="selectTab(tab.key)"
                            >{{ tab.label }}</a
                        >
                    </li>
                </ul>
                <div class="ml-auto d-flex align-items-center flex-shrink-0 pl-3">
                    <a
                        v-if="canCreateTemplate"
                        :href="createTemplateUrl"
                        class="btn btn-secondary btn-sm mr-2"
                        ><i class="far fa-layer-plus"></i> Skapa ny mall</a
                    >
                    <SbButton v-sb-toggle.settings variant="secondary" size="sm"
                        ><i class="fal fa-sliders"></i> Preferenser</SbButton
                    >
                </div>
            </div>

            <SbCollapse id="settings">
                <SbFormGroup label="Föredragna fält:" class="mb-3">
                    <div class="mr-2">
                        <div v-for="option in preferredFieldOptions" :key="option.key" class="custom-control custom-checkbox custom-control-inline">
                            <input :id="`preferred-field-${option.key}`" v-model="preferredFields" class="custom-control-input" type="checkbox" :value="option.key">
                            <label class="custom-control-label" :for="`preferred-field-${option.key}`">{{ option.label }}</label>
                        </div>
                    </div>
                </SbFormGroup>

                <div class="mb-3">
                    <div>Snabbfilter:</div>
                    <div
                        class="col d-flex justify-content-start flex-wrap d-flex-gap"
                    >
                        <a role="button" @click.prevent="filter.group = 'all'">
                            <span class="badge badge-pill badge-primary"
                                >Alla <i class="fal fa-file-alt ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'to_sign'"
                        >
                            <span class="badge badge-pill badge-primary"
                                >För signering
                                <i class="fal fa-file-signature ml-2"></i
                            ></span>
                        </a>

                        <a
                            role="button"
                            @click.prevent="filter.group = 'signed'"
                        >
                            <span class="badge badge-pill badge-success"
                                >Signerad
                                <i class="fal fa-file-signature ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'completed'"
                        >
                            <span class="badge badge-pill badge-success"
                                >Slutförd <i class="fal fa-trophy-alt ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'payed'"
                        >
                            <span class="badge badge-pill badge-success"
                                >Betalad <i class="fal fa-money-bill ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="
                                filter.group = 'externally_purchased'
                            "
                        >
                            <span class="badge badge-pill badge-success"
                                >Köpt i externt system
                                <i class="fal fa-money-bill ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'archived'"
                        >
                            <span class="badge badge-pill badge-success"
                                >Arkiverad
                                <i class="fal fa-box-archive ml-2"></i
                            ></span>
                        </a>

                        <a
                            role="button"
                            @click.prevent="filter.group = 'unpaid'"
                        >
                            <span class="badge badge-pill badge-warning"
                                >Ej betald
                                <i class="fal fa-search-dollar ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'onhold'"
                        >
                            <span class="badge badge-pill badge-warning"
                                >Betalning pausad
                                <i class="fal fa-search-dollar ml-2"></i
                            ></span>
                        </a>
                        <a role="button" @click.prevent="filter.group = 'note'">
                            <span class="badge badge-pill badge-warning"
                                >Kommentar
                                <i class="fal fa-engine-warning ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'invalid'"
                        >
                            <span class="badge badge-pill badge-warning"
                                >Ej giltig
                                <i class="fal fa-exclamation-triangle ml-2"></i
                            ></span>
                        </a>
                        <a
                            role="button"
                            @click.prevent="filter.group = 'missing_response'"
                        >
                            <span class="badge badge-pill badge-warning"
                                >Obesvarat <i class="fal fa-comments ml-2"></i
                            ></span>
                        </a>

                        <a
                            role="button"
                            @click.prevent="filter.group = 'duplicate'"
                        >
                            <span class="badge badge-pill badge-danger"
                                >Dubblett <i class="fal fa-copy ml-2"></i
                            ></span>
                        </a>

                        <a
                            role="button"
                            v-for="priority in priorities"
                            @click.prevent="filter.priority = priority.value"
                        >
                            <span
                                class="badge badge-pill"
                                :style="{ backgroundColor: priority.color }"
                            >
                                {{ priority.name }}
                                <i class="fal fa-star ml-2"></i>
                            </span>
                        </a>
                        <a
                            v-if="filter.group || filter.priority !== undefined"
                            role="button"
                            @click.prevent="
                                filter.group = null;
                                filter.priority = undefined;
                            "
                        >
                            <span class="badge badge-pill badge-danger"
                                ><i class="fal fa-times"></i
                            ></span>
                        </a>
                    </div>
                </div>
            </SbCollapse>
            <SbInputGroup class="mb-3">
                <SbInputGroupPrepend>
                    <SbInputGroupText
                        >Filtrera* <i class="fal fa-search ml-2"></i
                    ></SbInputGroupText>
                </SbInputGroupPrepend>

                <SbFormInput
                    v-model="filter.text"
                    type="text"
                    debounce="500"
                ></SbFormInput>
            </SbInputGroup>

            <SbTable
                ref="quotesTableRef"
                :items="provideItems"
                :fields="fields"
                :primary-key="primaryKey"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :filter="filter"
                :current-page="currentPage"
                :per-page="pageLimit"
                :class="currentTab !== 'mine' ? 'admin' : 'standard'"
                :tbody-tr-class="getRowClass"
                responsive
            >
                <template #row> </template>

                <template #cell(customer_name)="data">
                    {{ data.value }}
                    <span
                        v-show="quotesOnline.includes(data.item.key)"
                        class="ml-1 status-dot"
                    ></span>
                </template>
                <template #cell(leadscore)="data">
                    <div class="d-flex">
                        <h5
                            v-if="
                                data.value.value >= 40 && data.value.value < 51
                            "
                        >
                            😐
                        </h5>
                        <h5
                            v-if="
                                data.value.value >= 50 && data.value.value < 71
                            "
                        >
                            🚀
                        </h5>
                        <h5
                            v-if="
                                data.value.value >= 71 &&
                                data.value.value <= 100
                            "
                        >
                            🔥
                        </h5>
                    </div>
                </template>

                <template #cell(client_company)="data">
                    <small
                        v-if="data.value === 'Privatkund'"
                        style="opacity: 0.5"
                    >
                        <i class="fal fa-user-alt mr-1"></i> Privat
                    </small>
                    <small v-else>
                        <i class="fal fa-industry-alt mr-1"></i>
                        {{ data.value }}
                    </small>
                </template>

                <template #cell(formatted_quote_value)="data">
                    <div v-html="data.value"></div>
                </template>

                <template #cell(seller)="data">
                    <small v-if="data.value">
                        <img
                            v-if="data.value.avatar_url"
                            :src="data.value.avatar_url"
                            class="avatar-icon mr-1"
                        />
                        {{ data.value.name }}
                    </small>
                    <small v-else>N/A</small>
                </template>

                <template #cell(sales_note)="{ item, value }">
                    <template v-if="value">
                        <small
                            :id="`sales_note-${item.id}`"
                            :title="value"
                            class="ws-pre-line text-nowrap"
                            >{{ value.substring(0, 50)
                            }}{{ value.length > 100 ? "..." : "" }}</small
                        >
                    </template>
                    <small v-else>-</small>
                </template>

                <template #cell(products_options)="{ item, value }">
                    <div
                        v-if="value.type === 'products'"
                        class="d-flex justify-content-start d-flex-gap"
                        style="width: max-content"
                    >
                        <div v-for="(product, idx) in value.items">
                            <a
                                @click="
                                    currentQuote = item;
                                    currentOption = null;
                                    currentQuoteProduct = product;
                                "
                                :key="idx"
                                v-if="product.thumbnail_url"
                            >
                                <img-badge
                                    :src="product.thumbnail_url"
                                    :count="product.opened"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        v-else-if="value.type === 'options'"
                        class="d-flex justify-content-start d-flex-gap"
                        style="width: max-content"
                    >
                        <div v-for="(option, idx) in value.items">
                            <a
                                @click="
                                    currentQuote = item;
                                    currentQuoteProduct = null;
                                    currentQuoteOption = option;
                                "
                                :key="idx"
                                v-if="
                                    option.documents.length > 0 &&
                                    option.documents[0].pdf_thumbnail_url
                                "
                            >
                                <img-badge
                                    :src="option.documents[0].pdf_thumbnail_url"
                                    :count="option.opened"
                                />
                            </a>
                        </div>
                    </div>
                </template>

                <template #cell(statuses)="data">
                    <a
                        v-for="(statusItem, statusIdx) in data.value"
                        :key="statusIdx"
                        :href="statusItem.href"
                        class="ml-1"
                    >
                        <SbBadge pill :variant="statusItem.type">
                            {{ statusItem.title }}
                            <i
                                v-if="statusItem.icon"
                                :class="`fal fa-${statusItem.icon} ml-1`"
                            ></i>
                        </SbBadge>
                    </a>
                </template>

                <template #cell(priority)="data">
                    <SbDropdown
                        size="sm"
                        variant="default"
                        class="btn-default"
                        toggle-class="text-decoration-none text-dark"
                        no-caret
                        menu-class="z-index-dropdown"
                    >
                        <template #button-content>
                            <span
                                type="button"
                                class="text-dark text-decoration-none"
                                :style="{
                                    backgroundColor: data.value.color,
                                    padding: '5px 10px',
                                }"
                            >
                                {{ data.value.value }}
                            </span>
                        </template>
                        <SbDropdownItemButton
                            v-for="priority in priorities"
                            @click="
                                updatePriority(data.item.id, priority.value)
                            "
                            v-bind:key="priority.value"
                        >
                            {{ priority.name }}
                            <i
                                class="fal fa-check"
                                v-if="priority.value == data.value.value"
                            ></i>
                        </SbDropdownItemButton>
                    </SbDropdown>
                </template>

                <template #cell(tags)="data">
                    <SbBadge
                        v-for="(tagItem, tagIdx) in data.value"
                        :key="tagIdx"
                        class="ml-1"
                        pill
                        variant="secondary"
                    >
                        {{ tagItem }}
                    </SbBadge>
                </template>

                <template #cell(links)="data">
                    <div class="text-left d-flex">
                        <a
                            v-for="(linkItem, linkIndex) in data.value"
                            :key="linkIndex"
                            :href="linkItem.href"
                            :title="linkItem.title"
                            class="btn btn-default btn-sm float-left"
                        >
                            <i
                                v-if="linkItem.icon"
                                :class="`fal fa-${linkItem.icon}`"
                            ></i>
                        </a>
                        <SbDropdown
                            size="sm"
                            variant="default"
                            class="btn-default"
                            toggle-class="text-decoration-none text-dark"
                            no-caret
                            menu-class="z-index-dropdown"
                        >
                            <template #button-content>
                                <i class="fal fa-ellipsis-vertical"> </i
                                ><span class="sr-only">Dropdown</span>
                            </template>
                            <template v-if="!data.item.is_template">
                                <SbDropdownItemButton
                                        v-if="data.item.flow_status > 0"
                                        @click="play(data.item.id)"
                                    >
                                        <i class="far fa-play mr-1 fa-fw"></i>
                                        Starta uppföljning
                                    </SbDropdownItemButton>
                                    <SbDropdownItemButton
                                        v-else
                                        @click="pause(data.item.id)"
                                    >
                                        <i
                                            class="far fa-pause mr-1 fa-fw"
                                            style="grid-column: 1/5"
                                        ></i>
                                        Pausa uppföljning
                                    </SbDropdownItemButton>
                                <SbDropdownItemButton
                                        v-if="data.item.lost"
                                        @click="found(data.item.id)"
                                    >
                                        <i class="far fa-smile mr-1 fa-fw"></i>
                                        Har INTE tackat nej
                                    </SbDropdownItemButton>
                                    <SbDropdownItemButton
                                        v-else
                                        @click="lost(data.item.id)"
                                    >
                                        <i class="fal fa-frown mr-1 fa-fw"></i>
                                        Har tackat nej
                                    </SbDropdownItemButton>
                                <SbDropdownItemButton
                                    v-if="!data.item.delivered"
                                    @click="deliver(data.item.id)"
                                >
                                    <i class="far fa-truck mr-1 fa-fw"></i>
                                    Levererad
                                </SbDropdownItemButton>
                                <SbDropdownItemButton
                                        v-if="data.item.archived"
                                        @click="unarchive(data.item.id)"
                                    >
                                        <i
                                            class="far fa-box-open mr-1 fa-fw"
                                        ></i>
                                        Av-arkivera kontakt
                                    </SbDropdownItemButton>
                                    <SbDropdownItemButton
                                        v-else
                                        @click="archive(data.item.id)"
                                    >
                                        <i
                                            class="far fa-box-archive mr-1 fa-fw"
                                        ></i>
                                        Arkivera kontakt
                                    </SbDropdownItemButton>
                            </template>
                            <SbDropdownItemButton
                                @click="
                                    deleteQuote(
                                        data.item.id,
                                        data.item.is_template
                                    )
                                "
                            >
                                <i class="far fa-trash-alt mr-1 fa-fw"></i> Ta
                                bort
                                {{ data.item.is_template ? "mall" : "kontakt" }}
                            </SbDropdownItemButton>
                        </SbDropdown>
                    </div>
                </template>
            </SbTable>
            <div
                class="mt-3 d-flex flex-column justify-content-center align-items-center"
            >
                <SbSpinner v-if="!isLoaded" label="Laddar.."></SbSpinner>
            </div>

            <div class="d-flex justify-content-center align-items-center mt-3">
                <SbPagination
                    class="w-full"
                    v-model="currentPage"
                    :total-rows="quotesCount"
                    :per-page="pageLimit"
                ></SbPagination>
            </div>

            <ProductOptionPreview
                id="product-options-thumbnail-preview"
                :quote="currentQuote"
                :quoteProduct="currentQuoteProduct"
                :quoteOption="currentQuoteOption"
                @modal-closed="
                    currentQuote = null;
                    currentQuoteOption = null;
                    currentQuoteProduct = null;
                "
            >
                <template #edit-button>
                    <a class="btn btn-primary" :href="editQuoteUrl">Redigera</a>
                </template>
            </ProductOptionPreview>
        </div>
    </div>
</template>

<style lang="scss" scoped>
// The default Bootstrap nav-link colour is the theme primary (blue). For this
// tab strip we want plain body-text colour on inactive tabs; the active tab
// keeps Bootstrap's own styling.
.nav-tabs .nav-link:not(.active) {
    color: inherit;
}

table.admin td {
    font-size: 80%;
}

.avatar-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.ws-pre-line {
    white-space: pre-line;
}

.d-flex-gap {
    gap: 10px;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background: #22c55e;
    animation: status-pulse 1.4s ease-out infinite;
}
</style>

<script setup>
import { route } from "ziggy";
import { computed, onMounted, ref, watch } from "vue";
import { useSwal } from "../../composables/useSwal";
import { Axios } from "axios";
import ProductOptionPreview from "./modals/product_option_preview.vue";
import { formatSignableUntil } from "./formatSignableUntil";
const fieldCreatedAt = {
    key: "created_at",
    label: "Skickad",
    sortable: true,
    formatter: (value, key, item) => value.substring(0, 10),
};
const fieldQuoteProfileName = {
    key: "quote_profile_name",
    label: "Profil",
    sortable: true,
};
const fieldCustomerName = {
    key: "customer_name",
    label: "Namn",
    sortable: true,
};
const fieldClientCompany = {
    key: "client_company",
    label: "Typ",
    sortable: true,
    formatter: (value, key, item) => (value ? value : "Privatkund"),
};
const fieldFormattedQuoteValue = {
    key: "formatted_quote_value",
    label: "Värde",
    sortable: true,
};
const fieldSeller = {
    key: "seller",
    label: "Kontakt",
    sortable: true,
};
const fieldLatestCustomerInitiatedActionLogAt = {
    key: "latest_customer_initiated_action_log_at_text",
    label: "Senaste aktivitet",
    sortable: true,
    sortDirection: "desc",
};
const fieldLastSellerActivityAt = {
    key: "last_seller_activity_at",
    label: "Redigerad",
    sortable: true,
};
const fieldSignableUntil = {
    key: "signable_until",
    label: "Giltig tom",
    sortable: true,
    formatter: formatSignableUntil,
};
const fieldStatuses = {
    key: "statuses",
    label: "Status",
    sortable: false,
};
const fieldTags = {
    key: "tags",
    label: "Taggar",
    sortable: false,
};
const fieldLeadscore = {
    key: "leadscore",
    label: "Vera Score",
    sortable: true,
    sortDirection: "desc",
};
const fieldSalesNote = {
    key: "sales_note",
    label: "Note",
    sortable: true,
};
const fieldPriority = {
    key: "priority",
    label: "Prio",
    sortable: true,
    sortDirection: "desc",
};
const fieldProductOptions = {
    key: "products_options",
    label: "Erbjudande",
    sortable: false,
};
const fieldLinks = {
    key: "links",
    label: "",
    sortable: false,
};
const fieldTemplateName = {
    key: "template_name",
    label: "Mallnamn",
    formatter: (value, key, item) => (value ? value : value),
    sortable: true,
};
const adminFields = [
    fieldLinks,
    fieldCreatedAt,
    fieldLeadscore,
    fieldQuoteProfileName,
    fieldCustomerName,
    fieldClientCompany,
    fieldFormattedQuoteValue,
    fieldLatestCustomerInitiatedActionLogAt,
    fieldLastSellerActivityAt,
    fieldSignableUntil,
    fieldSeller,
    fieldStatuses,
    fieldPriority,
    fieldTags,
    fieldSalesNote,
    fieldProductOptions,
];
const standardFields = [
    fieldLinks,
    fieldCreatedAt,
    fieldLeadscore,
    fieldQuoteProfileName,
    fieldCustomerName,
    fieldClientCompany,
    fieldFormattedQuoteValue,
    fieldLatestCustomerInitiatedActionLogAt,
    fieldLastSellerActivityAt,
    fieldSignableUntil,
    fieldStatuses,
    fieldPriority,
    fieldTags,
    fieldSalesNote,
    fieldProductOptions,
];
const templateFields = [
    fieldLinks,
    fieldCreatedAt,
    fieldTemplateName,
    fieldQuoteProfileName,
    fieldTags,
    fieldSalesNote,
    fieldProductOptions,
];
const swal = useSwal();
const quotesTableRef = ref(null);
const props = defineProps({
    tabs: {
        type: Array,
        default: () => [],
    },
    defaultTab: {
        type: String,
        default: "mine",
    },
    templatesOnly: {
        type: Boolean,
        default: false,
    },
    searchQuery: {
        type: String,
        default: null,
    },
    companyId: {
        type: Number,
        default: null,
    },
    initialQuotesOnline: {
        type: Array,
        default: () => [],
    },
    canCreateTemplate: {
        type: Boolean,
        default: false,
    },
    createTemplateUrl: {
        type: String,
        default: null,
    },
});
const currentTab = ref(props.defaultTab);
const primaryKey = ref("id");
const sortBy = ref("created_at");
const sortDesc = ref(true);
const filter = ref({
    text: null,
    group: null,
    priority: undefined,
});
const quoteProfileNameCount = ref(0);
const tagCount = ref(0);
const isLoaded = ref(false);
const currentPage = ref(1);
const pageLimit = ref(50);
const quotesCount = ref(null);
const currentQuote = ref(null);
const currentQuoteProduct = ref(null);
const currentQuoteOption = ref(null);
const preferredFields = ref([]);
const priorities = ref([]);
const quotesOnline = ref([...props.initialQuotesOnline]);
const baseFields = computed(() => {
    let fields = currentTab.value !== "mine" || filter.value.text ? adminFields : standardFields;
    if (props.templatesOnly) {
        fields = templateFields;
    }
    return fields
        .filter((field) => {
            return (
                field.key !== "quote_profile_name" ||
                quoteProfileNameCount.value > 1
            );
        })
        .filter((field) => {
            return field.key !== "tags" || tagCount.value > 0;
        });
});
const fields = computed(() => {
    return baseFields.value.filter((field) => {
        if (field.key === "links") {
            return true;
        }
        return preferredFields.value.includes(field.key);
    });
});
const editQuoteUrl = computed(() => {
    if (currentQuoteOption.value || currentQuoteProduct.value) {
        return route("quotes.edit", [currentQuote.value.id]);
    }
    return "#";
});
const preferredFieldOptions = computed(() => {
    return baseFields.value.filter((field) => field.key !== "links");
});
function selectTab(key) {
    if (currentTab.value === key) {
        return;
    }
    currentTab.value = key;
    if (quotesTableRef.value) {
        quotesTableRef.value.refresh();
    }
}
function getRowClass(item, type) {
    let classes = "text-nowrap";
    if (item.last_seller_activity_passed_threshold === null) {
        classes += " table-warning";
    } else if (item.last_seller_activity_passed_threshold) {
        classes += " table-danger";
    }
    return classes;
}
const SIGNABLE_UNTIL_FIELD_KEY = "signable_until";
const SIGNABLE_UNTIL_MIGRATION_MARKER = "preferredFieldsSignableUntilAdded";
function savePreferredFields(fieldsToSave) {
    localStorage.setItem("preferredFields", JSON.stringify(fieldsToSave));
}
function getPreferredFields() {
    let fields = localStorage.getItem("preferredFields");
    if (fields === null) {
        return [];
    }
    fields = JSON.parse(fields);
    if (!Array.isArray(fields)) {
        return [];
    }
    return fields;
}
function hasAddedSignableUntil() {
    return localStorage.getItem(SIGNABLE_UNTIL_MIGRATION_MARKER) !== null;
}
function markSignableUntilAdded() {
    localStorage.setItem(SIGNABLE_UNTIL_MIGRATION_MARKER, "true");
}
function appendSignableUntilOnce(fields) {
    if (fields.includes(SIGNABLE_UNTIL_FIELD_KEY)) {
        if (!hasAddedSignableUntil()) {
            markSignableUntilAdded();
        }
        return fields;
    }
    if (hasAddedSignableUntil()) {
        return fields;
    }
    markSignableUntilAdded();
    return [...fields, SIGNABLE_UNTIL_FIELD_KEY];
}
function setPreferredFields() {
    let storedPreferredFields = getPreferredFields();
    let fieldsChanged = storedPreferredFields.length === 0;
    if (fieldsChanged) {
        storedPreferredFields = preferredFieldOptions.value.map(
            ({ key }) => key
        );
    }
    const migratedFields = appendSignableUntilOnce(storedPreferredFields);
    fieldsChanged = fieldsChanged || migratedFields !== storedPreferredFields;
    if (fieldsChanged) {
        savePreferredFields(migratedFields);
    }
    preferredFields.value = migratedFields;
}
async function provideItems(ctx) {
    isLoaded.value = false;
    try {
        let url = `/offerter?page=${ctx.currentPage}&per_page=${ctx.perPage}`;
        if (ctx.sortBy) {
            url += `&sort_by=${ctx.sortBy}&sort_desc=${ctx.sortDesc ? 1 : 0}`;
        }
        if (ctx.filter && ctx.filter.text) {
            url += `&filter_text=${ctx.filter.text}`;
        }
        if (ctx.filter && ctx.filter.group) {
            url += `&filter=${ctx.filter.group}`;
        }
        if (ctx.filter && ctx.filter.priority !== undefined) {
            url += `&filter_priority=${
                Number(ctx.filter.priority) === 0 ? "zero" : ctx.filter.priority
            }`;
        }
        url += `&tab=${currentTab.value}`;
        if (props.templatesOnly) {
            url += "&templates_only=true";
        }
        const response = await axios.get(url);
        const quotes = response.data.data;
        quoteProfileNameCount.value += new Set(
            quotes.map((item) => item.quote_profile_name)
        ).size;
        tagCount.value += new Set(quotes.flatMap((item) => item.tags)).size;
        quotesCount.value = response.data.meta.total;
        setPreferredFields();
        isLoaded.value = true;
        return quotes;
    } catch (error) {
        console.error(error);
        return [];
    } finally {
        isLoaded.value = true;
    }
}
async function play(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.play", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function pause(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.pause", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function found(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.found", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function lost(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.lost", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function archive(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.archive", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function unarchive(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.unarchive", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function deliver(id) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.deliver", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function updatePriority(id, priority) {
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.updatePriority", id), {
            priority,
        });
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
async function deleteQuote(id, is_template) {
    let alert = null;
    if (is_template) {
        try {
            const response = await axios.get(route("quotes.getForms", id));
            let message = "Vill du fortsätta att radera?";
            if (response.data && response.data.length > 0) {
                message = `Denna mall har ${
                    response.data.length
                } formulär [${response.data
                    .map((form) => form.name)
                    .join(",")}] bifogade, vill du fortfarande ta bort?`;
            }
            alert = await swal.fire({
                text: message,
                icon: "question",
                confirmButtonText: "Fortsätta",
                confirmButtonColor: window
                    .getComputedStyle(document.body)
                    .getPropertyValue("--primary-color"),
                showCancelButton: true,
            });
        } catch (e) {
            console.log(e);
            return;
        }
    } else {
        alert = await swal.fire({
            text: "Vill du fortsätta att radera?",
            icon: "question",
            confirmButtonColor: window
                .getComputedStyle(document.body)
                .getPropertyValue("--primary-color"),
            showCancelButton: true,
        });
    }
    if (!alert || !alert.isConfirmed) {
        return;
    }
    isLoaded.value = false;
    try {
        const response = await axios.post(route("quotes.delete", id));
        quotesTableRef.value.refresh();
    } catch (error) {
        console.error(error);
    } finally {
        isLoaded.value = true;
    }
}
watch(preferredFields, (value) => {
    savePreferredFields(value);
});
watch(
    () => filter.value.text,
    (value, previousValue) => {
        if (!value && previousValue) {
            currentTab.value = props.defaultTab;
        }
    }
);
onMounted(() => {
    if (props.searchQuery) {
        filter.value = {
            text: props.searchQuery,
            group: null,
            priority: undefined,
        };
    }
    axios.get(route("utilities.priorities")).then((response) => {
        priorities.value = response.data;
    });
    if (props.companyId) {
        window.Echo.private(
            `Company.${props.companyId}.Quotes.Online.Status`
        ).listen("Quote\\CustomerOnlineStatusUpdated", (e) => {
            if (e.isOnline && !quotesOnline.value.includes(e.quoteKey)) {
                quotesOnline.value.push(e.quoteKey);
            } else if (!e.isOnline && quotesOnline.value.includes(e.quoteKey)) {
                quotesOnline.value = quotesOnline.value.filter(
                    (quoteKey) => quoteKey !== e.quoteKey
                );
            }
        });
    }
});
</script>
